module.exports = __webpack_public_path__ + "static/media/consumedEnergy.bb4b914e.png";